import React from "react";
import { IQuantityProps } from "./Quantity.props";
import cn from "classnames";

import styles from "./Quantity.module.scss";
import { useIntl } from "react-intl";

export default function Quantity(props: IQuantityProps) {
  const { formatMessage } = useIntl();
  return (
    <div className={styles.wrapper}>
      <label>{formatMessage({ id: "modal.spare_part.name.quantity" })}</label>
      <div className={styles.quantity}>
        <button>-</button> <div className={styles.value}>10</div>{" "}
        <button>+</button>
      </div>
    </div>
  );
}
